<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{on}">
        <v-btn small icon
               :color="getColor"
               v-on="on"
               @click="onBtnClick"
        >
          <v-icon>receipt</v-icon>
        </v-btn>
      </template>
      {{ receipt ? receipt.Estado : 'Sin Factura generada' }}
      {{ getReceiptError }}
    </v-tooltip>

    <confirm-dialog
        v-model="confirmDialog"
        :title="getConfirmTitle"
        :description="getConfirmDesc"
        @confirmed="onConfirmed"
    >

    </confirm-dialog>


    <factura-dialog v-if="receipt" @emitted="onEmitted" :dialog="showReceipt" :receipt="receipt" @close="showReceipt = false"></factura-dialog>

  </div>
</template>

<script>
import {ConfirmDialog} from "@dracul/common-frontend";
import AfipOrderProvider from "@/modules/delivery/providers/AfipOrderProvider";
import AfipProvider from "@/modules/afip/providers/AfipProvider";
import FacturaDialog from "@/modules/afip/components/FacturaDialog/FacturaDialog";

export default {
  name: "ReceiptHandler",
  components: {FacturaDialog,  ConfirmDialog},
  props: {
    order: {type: Object}
  },
  data() {
    return {
      showReceipt: false,
      confirmDialog: false,
      receipt: this.order.receipt ? this.order.receipt : null
    }
  },
  computed: {
    getColor() {
      if (!this.receipt) return 'purple'
      if (this.receipt.Estado === 'PENDIENTE') return 'orange'
      if (this.receipt.Estado === 'ERROR') return 'red'
      if (this.receipt.Estado === 'FACTURADO') return 'teal'
      return 'grey'
    },
    getConfirmTitle() {
      if (!this.receipt) return 'Generar factura'
      if (this.receipt.Estado === 'PENDIENTE' || this.receipt.Estado === 'ERROR') return 'Emitir factura AFIP'
      return ''
    },
    getConfirmDesc() {
      if (!this.receipt) return '¿Esta seguro de generar una factura?'
      if (this.receipt.Estado === 'PENDIENTE' || this.receipt.Estado === 'ERROR') return '¿Esta seguro de emitir la factura hacia AFIP?'
      return ''
    },
    getReceiptError() {
      if (this.receipt && this.receipt.Error) {
        return this.receipt.Error
      }
      return null
    }
  },
  methods: {
    onEmitted(receipt){
      this.receipt = receipt
    },
    onBtnClick() {
      if (!this.receipt) {
        this.confirmDialog = true
      }else{
        this.showReceipt = true
      }
    },
    onConfirmed() {
      if (!this.receipt) {
        this.createReceipt()
      } else if (this.receipt.Estado === 'PENDIENTE' || this.receipt.Estado === 'ERROR') {
        this.emitReceipt()
      }
    },
    createReceipt() {
      AfipOrderProvider.createOrderReceipt(this.order.id)
          .then(r => {
            this.receipt = r.data.createOrderReceipt
          })
    },
    emitReceipt() {
      AfipProvider.createElectronicBilling(this.receipt.id)
          .then(r => {
            this.receipt = r.data.createElectronicBilling
          })
    }
  }
}
</script>

<style scoped>

</style>
